export default {
  kidsBadge: "باشگاه آموزش شاد زبان",
  playAndLearnWorld: "سرزمین یادگیری و بازی",
  smartKidsSite: "ویژه کودکان باهوش",
  footerBrandDesc: "با بازی‌های تعاملی، انیمیشن و کاربرگ‌های رنگی، یادگیری زبان انگلیسی را به یک ماجراجویی هیجان‌انگیز تبدیل می‌کنیم!",
  learningFeaturesTitle: "دنیای ماجراجویی ما",
  games: "بازی‌های فکری",
  videos: "کارتون و ویدیو",
  songs: "شعر و آهنگ",
  worksheets: "کاربرگ‌ها",
  stories: "داستان صوتی",
  painting: "رنگ‌آمیزی",
  contactUs: "پشتیبانی و ارتباط",
  phoneNumber: "شماره تماس",
  email: "ایمیل پشتیبانی",
  parentsSafeBadge: "محیطی ۱۰۰٪ امن و کنترل‌شده ویژه کودکان",
  allRightsReserved: "تمامی حقوق برای سرزمین کودکان محفوظ است",
  footer_copyright_prefix: '🎈 تمامی حقوق برای',
  footer_copyright_company: 'ایران فونیکس',
  footer_copyright_suffix: 'محفوظ است 🚀',
  footer_dev_credit_prefix: 'طراحی و توسعه توسط',
  footer_dev_credit_company: 'شنو سافت',
  footer_address_title: '📍 محل ماجراجویی ما',
  footer_address_text: 'تهران، انقلاب، خیابان ۱۲ فروردین، نبش روانمهر، پلاک ۲۵۶',
};
